import { render, staticRenderFns } from "./OfCreate.vue?vue&type=template&id=3e16dc58&scoped=true&"
import script from "./OfCreate.vue?vue&type=script&lang=js&"
export * from "./OfCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfCreate.vue?vue&type=style&index=0&id=3e16dc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16dc58",
  null
  
)

export default component.exports